import React, { useState } from 'react';
import '../../../../../App.css';
import { Layout } from '../../layout';

import { NumericFormat } from 'react-number-format';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import {
  useCreateSinglePaymentRequest,
  useCreateSinglePaymentRequestMESTRO,
  useGetBatchId,
  useGetUserBankDetails,
} from '../hooks/usePayment';
import { Modal } from 'antd';
import { phoneRegExp } from '../../../../../core/helpers/RegexHelpers';
import {
  useDoAccountNameVerification,
  useGetBankInstitutions,
} from '../../../auth/hooks/useUser';

const Schema = Yup.object().shape({
  expenseType: Yup.string().required('Expense type is required'),
  amountToPay: Yup.string().required('Amount to pay is required'),
  accountNumber: Yup.string()
    .required('Account number is required')
    .matches(/^[0-9]{10}$/, 'Invalid account number')
    .max(10, 'Account number must be at most 10 characters long'),
  bankName: Yup.string().required('Bank name is required'),
  // accountName: Yup.string()
  //   .required("Account name is required")
  //   .max(30, "Text field must be at most 30 characters long"),
  emailAddress: Yup.string()
    .required('Email address is required')
    .email('Wrong email format'),
  phoneNumber: Yup.string()
    .required('Phone Number is required')
    .matches(phoneRegExp, 'Phone number is not valid'),

  // description: Yup.string().required("Description is required"),
});

const initialValues = {
  expenseType: '',
  amountToPay: '',
  accountToMakePaymentFrom: '',
  accountNumber: '',
  bankName: '',
  accountName: '',
  emailAddress: '',
  phoneNumber: '',
  description: '',
};

const RetailVendorPayments = () => {
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [step, setStep] = useState<number>(1);

  const { data, error, mutate, isLoading } = useCreateSinglePaymentRequest();

  const {
    data: dataMestro,
    error: errorMestro,
    mutate: mutateMestro,
    isLoading: isLoadingMestrol,
  } = useCreateSinglePaymentRequestMESTRO();

  const {
    data: bankData,
    mutate: mutateBankData,
    isLoading: isLoadingBankData,
  } = useGetUserBankDetails();
  const {
    data: bankList,
    mutate: mutateBankList,
    isLoading: isLoadingBankList,
  } = useGetBankInstitutions();
  const {
    data: nameEnquiry,
    mutate: mutateNameEnquiry,
    isLoading: isLoadingNameEnquiry,
  } = useDoAccountNameVerification();
  const {
    data: batchId,
    mutate: mutateBatchId,
    isLoading: isLoadingBatchId,
  } = useGetBatchId();

  React.useEffect(() => {
    mutateBatchId();
  }, []);

  const redirect = () => {
    setSuccessModal(false);
    setStep(1);
    formik.resetForm();
    mutateBatchId();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    mutateBankData();
    mutateBankList();
  }, [step]);

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: async (values) => {
      setConfirmationModal(false);
      const accountData = values.accountToMakePaymentFrom.split('-');
      const destinationBank = values.bankName.split('-');

      console.log(destinationBank[0]);

      if (destinationBank[0] === '009234') {
        mutateMestro(
          {
         
              accountNumber:  values?.accountNumber,
              amount: values.amountToPay,
              sourceAccountNumber: accountData[0],
              narration: values?.description,
           
          },
          {
            onSuccess: (res: any) => {
              setSuccessModal(true);
            },
          }
        );
      } else {
        mutate(
          {
            data: {
              batchId: batchId,
              narration: values?.description,
              accountType: {
                code: accountData[2],
                value: accountData[3],
              },
              expenseType: values.expenseType,
              paymentType: {
                code: 'RetailVendor',
                description: 'Retail Vendor Payment',
              },
              paymentInstructions: [
                {
                  sourceAccount: accountData[0],
                  destinationAccount: values.accountNumber,
                  narration: values?.description,
                  amount: values.amountToPay,
                  sourceName: accountData[1],
                  paymentStatus: 'NEW',
                  paymentType: {
                    code: 'RetailVendor',
                    description: 'Retail Vendor Payment',
                  },
                  destinationName: nameEnquiry?.accountName,
                  destAccountName: nameEnquiry?.accountName,
                  destinationInstitutionCode: destinationBank[0],
                  sourceInstitutionCode: accountData[2],
                  email: values.emailAddress,
                  phoneNumber: values.phoneNumber,
                  sourceBankAccountCode: accountData[2],
                  destinationBankAccountCode: destinationBank[0],
                },
              ],
            },
          },
          {
            onSuccess: (res: any) => {
              setSuccessModal(true);
            },
          }
        );
      }
    },
  });

  //console.log(formik.errors.accountNumber);

  let expenseType = [
    {
      id: '',
      description: 'Select expense type',
    },
    {
      id: 2,
      description: 'Capital',
    },
    {
      id: 3,
      description: 'Overhead',
    },
    {
      id: 3,
      description: 'Personnel',
    },
  ];

  let paymentFrom = [
    {
      id: '',
      description: 'Select account to make payment from',
    },
    {
      id: 1,
      description: 'Fidelity - 0123456789',
    },
    {
      id: 2,
      description: 'First Bank - 5478962486',
    },
    {
      id: 3,
      description: 'GTB - 6587458125',
    },
  ];

  function doNameEnquiry() {
    // formik.values.bankName.split("-")[1],
    console.log(formik.values.bankName.split('-')[1]);

    var bankCode = formik.values.bankName.split('-')[0];

    if (bankCode === '009234') {
      return;
    } else {
      mutateNameEnquiry(
        {
          accountNumber: formik.values.accountNumber,
          destinationInstitutionCode: bankCode,
        },
        {
          onSuccess: (res: any) => {
            // setSuccessModal(true);
          },
        }
      );
    }
  }


  const formatCurrency = (value, currency = 'USD') => 
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value);

  return (
    <>
      <div className={'retailVendorPage'}>
        <div className={'retailVendorBreadcrumb'}>
          <div>Payments</div>
          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>
          <div>Retail/Vendor Payments</div>
        </div>

        <div className="pb-15 pt-2">
          {/* <div className="  m-auto my-7e responsive-card overflow-none d-flex  flex-column">
            <div className="d-flex align-items-center">
              <span
                className={`fw-bold fs-9 ${
                  step >= 1 ? 'touched-step' : 'unTouched-step'
                }`}
              >
                1
              </span>

              <span
                className={`mx-1 ${
                  step >= 1 ? 'touched-line' : 'unTouched-line'
                }`}
              />

              <span
                className={`fw-bold fs-9 ${
                  step >= 2 ? 'touched-step' : 'unTouched-step'
                }`}
              >
                2
              </span>

              <span
                className={`mx-1  ${
                  step === 3 ? 'touched-line' : 'unTouched-line'
                }`}
              />

              <span
                className={`fw-bold fs-9 ${
                  step === 3 ? 'touched-step' : 'unTouched-step'
                }`}
              >
                3
              </span>
            </div>

            <div className="d-flex justify-content-between my-4">
              <span className="fs-9 ">Step 1 of 3</span>

              <span className="fs-9 ">Step 2 of 3</span>

            </div>
          </div> */}

          <form
            onSubmit={formik.handleSubmit}
            noValidate
            className="retailVendorForm"
          >
            {step === 1 && (
              <>
                <div className={'rvTitle'}>Make Vendor Payment</div>

                <div className={`mt-1`}>
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.expenseType.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Select expense type
                      </label>
                    )}
                  </div>

                  <div className={`form-control form-control-solid`}>
                    <select
                      className={`no-outline fs-8 ${
                        formik.values.expenseType !== ''
                          ? 'text-dark'
                          : 'text-muted'
                      } `}
                      {...formik.getFieldProps('expenseType')}
                      placeholder="Select expense type*"
                    >
                      {expenseType &&
                        expenseType?.map((array: any, i: any) => {
                          return (
                            <option value={array?.description} key={i}>
                              {array?.description}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.expenseType &&
                        formik.errors.expenseType &&
                        formik.errors.expenseType}
                    </div>
                  </div>
                </div>

                <div className={`mt-1`}>
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik?.values?.amountToPay?.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Amount to pay
                      </label>
                    )}
                  </div>
                  <div className={'form-control form-control-solid'}>
                    <NumericFormat
                      type="text"
                      prefix="₦"
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      className="no-outline text-dark fs-8"
                      placeholder="Amount to pay*"
                      allowNegative={false}
                      allowLeadingZeros={false}
                      decimalScale={2}
                      onValueChange={(event) =>
                        formik.setFieldValue('amountToPay', event.floatValue)
                      }
                    />
                  </div>
                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched?.amountToPay &&
                        formik.errors?.amountToPay &&
                        formik.errors?.amountToPay}
                    </div>
                  </div>
                </div>

                <div className={`mt-1`}>
                  <div className="col-lg-7 col-form-label py-0 input-height">
                    {formik.values.accountToMakePaymentFrom.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Select account to make payment from
                      </label>
                    )}
                  </div>

                  <div className={`form-control form-control-solid`}>
                    <select
                      className={`no-outline fs-8 ${
                        formik.values.accountToMakePaymentFrom !== ''
                          ? 'text-dark'
                          : 'text-muted'
                      } `}
                      {...formik.getFieldProps('accountToMakePaymentFrom')}
                      placeholder="Select account to make payment from*"
                    >
                      <option value="">
                        Select account to make payment from
                      </option>
                      {bankData && bankData?.map((array: any, i: any) => {
                        return (
                          <option
                            value={`${array?.accountNumber}-${array?.bankName}-${array?.institutionCode}-}`}
                            key={i}
                          >
                            {array?.bankName}- {array?.accountNumber} - {formatCurrency(array?.balance || 0, 'NGN') }
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.accountToMakePaymentFrom &&
                        formik.errors.accountToMakePaymentFrom &&
                        formik.errors.accountToMakePaymentFrom}
                    </div>
                  </div>
                </div>

                <div className={'beneficiaryDetails'}>Beneficiary Details</div>

                <div className={`mt-1`}>
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.bankName.length !== 0 && (
                      <label className="required fw-bold fs-9">Bank name</label>
                    )}
                  </div>

                  <div className={`form-control form-control-solid`}>
                    <select
                      className={`no-outline fs-8 ${
                        formik.values.accountToMakePaymentFrom !== ''
                          ? 'text-dark'
                          : 'text-muted'
                      } `}
                      {...formik.getFieldProps('bankName')}
                      placeholder="Select a bank"
                      onBlur={doNameEnquiry}
                    >
                      <option value="">Select a bank</option>
                      {bankList?.map((bank) => (
                        <>
                          <option
                            key={bank.institutionCode}
                            value={`${bank.institutionCode}-${bank.institutionName}`}
                          >
                            {bank?.institutionName}
                          </option>
                        </>
                      ))}
                      <option key="009234" value="009234-Mestro MFB">
                        Maestro MFB
                      </option>
                    </select>
                  </div>

                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.accountToMakePaymentFrom &&
                        formik.errors.accountToMakePaymentFrom &&
                        formik.errors.accountToMakePaymentFrom}
                    </div>
                  </div>
                </div>

                <div className={`mt-1`}>
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.accountNumber.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Account number
                      </label>
                    )}
                  </div>
                  <div className={'form-control form-control-solid'}>
                    <NumericFormat
                      type="text"
                      prefix=""
                      thousandsGroupStyle="thousand"
                      thousandSeparator=""
                      className="no-outline text-dark fs-8"
                      {...formik.getFieldProps('accountNumber')}
                      placeholder="Account number*"
                      allowNegative={false}
                      allowLeadingZeros={true}
                      onBlur={doNameEnquiry}
                    />
                  </div>
                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.accountNumber ||
                        formik.errors.accountNumber ||
                        formik.errors.accountNumber}
                    </div>
                  </div>

                  {/*<div>Beneficiary Details</div>*/}
                </div>

                {/*<div className="mt-1">*/}
                {/*    <div className="col-lg-4 col-form-label py-0 input-height">*/}
                {/*        {formik.values.bankName.length !== 0 && (*/}
                {/*            <label className="required fw-bold fs-9">Bank name</label>*/}
                {/*        )}*/}
                {/*    </div>*/}
                {/*    <div className={`form-control form-control-solid`}>*/}
                {/*        <input*/}
                {/*            type="text"*/}
                {/*            placeholder="Bank name*"*/}
                {/*            className={'no-outline text-dark fs-8'}*/}
                {/*            {...formik.getFieldProps('bankName')}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <div className="fv-plugins-message-container input-height">*/}
                {/*        <div className="fv-help-block fs-9 text-danger">*/}
                {/*            {formik.touched.bankName &&*/}
                {/*                formik.errors.bankName &&*/}
                {/*                formik.errors.bankName}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="mt-1">
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.accountName.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Account name
                      </label>
                    )}
                  </div>
                  <div className={`form-control form-control-solid`}>
                    <input
                      type="text"
                      placeholder="Account name*"
                      className={'no-outline text-dark fs-8'}
                      {...formik.getFieldProps('accountName')}
                      value={nameEnquiry ? nameEnquiry?.accountName : null}
                    />
                  </div>
                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.accountName &&
                        formik.errors.accountName &&
                        formik.errors.accountName}
                    </div>
                  </div>
                </div>

                <div className="mt-1">
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.emailAddress.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Email address
                      </label>
                    )}
                  </div>
                  <div className={`form-control form-control-solid`}>
                    <input
                      type="email"
                      placeholder="Email address"
                      className={'no-outline text-dark fs-8'}
                      {...formik.getFieldProps('emailAddress')}
                    />
                  </div>
                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.emailAddress &&
                        formik.errors.emailAddress &&
                        formik.errors.emailAddress}
                    </div>
                  </div>
                </div>

                <div className="mt-1">
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.phoneNumber.length !== 0 && (
                      <label className="required fw-bold fs-9">
                        Phone number
                      </label>
                    )}
                  </div>
                  <div className={`form-control form-control-solid`}>
                    <input
                      type="tel"
                      placeholder="Phone number"
                      className={'no-outline text-dark fs-8'}
                      {...formik.getFieldProps('phoneNumber')}
                    />
                  </div>
                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.phoneNumber &&
                        formik.errors.phoneNumber &&
                        formik.errors.phoneNumber}
                    </div>
                  </div>
                </div>

                <div className="mt-1">
                  <div className="col-lg-4 col-form-label py-0 input-height">
                    {formik.values.description.length !== 0 && (
                      <label className="fw-bold fs-9">Description</label>
                    )}
                  </div>
                  <div className={`form-control form-control-solid`}>
                    <input
                      type="tel"
                      placeholder="Description"
                      className={'no-outline text-dark fs-8'}
                      {...formik.getFieldProps('description')}
                    />
                  </div>
                  <div className="fv-plugins-message-container input-height">
                    <div className="fv-help-block fs-9 text-danger">
                      {formik.touched.description &&
                        formik.errors.description &&
                        formik.errors.description}
                    </div>
                  </div>
                </div>

                <div>
                  {/*{*/}
                  {/*    formik.isValid && formik.dirty ?*/}
                  {/*        <button*/}
                  {/*            className="btn btn-success px-7 py-2 h-44 w-110 rounded-1 "*/}
                  {/*            onClick={() => setStep(2)}*/}
                  {/*        >*/}
                  {/*    <span className="indicator-label fs-base text-White">*/}
                  {/*      Proceed*/}
                  {/*    </span>*/}
                  {/*        </button> : <button disabled*/}
                  {/*                    className="btn btn-success px-7 py-2 h-44 w-110 rounded-1 "*/}
                  {/*                    style={{background: '#666666'}}*/}
                  {/*        >*/}
                  {/*    <span className="indicator-label fs-base text-White">*/}
                  {/*      Proceed*/}
                  {/*    </span>*/}
                  {/*        </button>*/}
                  {/*}*/}

                  {formik.isValid && formik.dirty ? (
                    <button
                      className="btn btn-success px-7 py-2 h-44 w-110 rounded-1 "
                      onClick={() => setStep(2)}
                    >
                      <span className="indicator-label fs-base text-White">
                        Proceed
                      </span>
                    </button>
                  ) : (
                    <button
                      disabled
                      className="btn btn-success px-7 py-2 h-44 w-110 rounded-1 "
                      style={{ background: '#666666' }}
                    >
                      <span className="indicator-label fs-base text-White">
                        Proceed
                      </span>
                    </button>
                  )}
                  {/*<button*/}
                  {/*    className="btn btn-success px-7 py-2 h-44 w-110 rounded-1 "*/}
                  {/*    onClick={() => setStep(2)}*/}
                  {/*>*/}
                  {/*    <span className="indicator-label fs-base text-White">*/}
                  {/*      Proceed*/}
                  {/*    </span>*/}
                  {/*</button>*/}
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <div className={'retailVendorConfirmDetails'}>
                  <div className={'confirmDetailTitle'}>Confirm Details</div>
                  <div>
                    <div>
                      <span>Expense Type</span>
                      <div> {formik.values.expenseType} </div>
                    </div>
                    <div>
                      <span>Funding account</span>
                      <div>{formik.values.accountToMakePaymentFrom}</div>
                    </div>
                    <div>
                      <span>Amount</span>
                      <div> {formik?.values?.amountToPay} </div>
                    </div>
                  </div>

                  <div>
                    <span>Beneficiary Details</span>

                    <div>
                      <span>Bank name</span>
                      <div>{formik.values.bankName.split('-')[1]} </div>
                    </div>
                    <div>
                      <span>Account number</span>
                      <div> {formik.values.accountNumber} </div>
                    </div>
                    <div>
                      <span>Account name</span>
                      <div> {nameEnquiry?.accountName} </div>
                    </div>
                  </div>

                  <div>
                    <span>Additional Information</span>

                    <div>
                      <span>Email address</span>
                      <div> {formik.values.emailAddress} </div>
                    </div>
                    <div>
                      <span>Phone number</span>
                      <div> {formik.values.phoneNumber} </div>
                    </div>
                    <div>
                      <span>Description</span>
                      <div> {formik.values.description} </div>
                    </div>
                  </div>

                  <div className={'vrActionButtons'}>
                    <button
                      className="btn btn-outline-success px-7 py-2 h-44 w-110 rounded-1 "
                      onClick={() => setStep(1)}
                    >
                      <span className="indicator-label fs-base">Edit</span>
                    </button>

                    {/*This button is meant to submit the form */}
                    <button type="submit" hidden id="submitForm"></button>

                    {/*This button is meant to open the modal*/}
                    <button
                      type={'button'}
                      onClick={() => setConfirmationModal(true)}
                      id="kt_password_cancel "
                      // type="submit"
                      className={`btn nav-btn-Proceed ${
                        isLoading ? 'btn-secondary' : 'btn-success'
                      } text-white px-7 py-2`}
                      disabled={isLoading}
                      // onClick={(e) => handleNextStep(e)}
                    >
                      {!isLoading && (
                        <span className="indicator-label">Confirm</span>
                      )}
                      {isLoading && (
                        <span
                          className="indicator-progress"
                          style={{ display: 'block' }}
                        >
                          Please wait...{' '}
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>

        <Modal
          centered
          style={{ width: '500px', maxWidth: '100%' }}
          open={confirmationModal}
          onOk={() => setConfirmationModal(false)}
          onCancel={() => setConfirmationModal(false)}
          footer={null}
        >
          <div className={'rvpConfirmationModal'}>
            <svg
              style={{ justifySelf: 'center' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                fill="#61CD85"
              />
            </svg>

            {/*<div className={'rdFilterModalRow1'}>*/}
            <div className={'rvpConfirmationModalTitle'}>Confirmation</div>
            {/*</div>*/}

            <div style={{ justifySelf: 'center' }}>
              Please confirm you want to proceed with this request
            </div>

            <div className={'rvpConfirmationModalActionButton'}>
              <button
                className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1 "
                onClick={() => setConfirmationModal(false)}
              >
                <span className="indicator-label fs-base">Cancel</span>
              </button>

              <button
                onClick={() => {
                  const submitButton = document.getElementById(
                    'submitForm'
                  ) as HTMLButtonElement;
                  submitButton.click();
                }}
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
              >
                <span className="indicator-label fs-base text-White">
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          centered
          style={{ width: '500px', maxWidth: '100%' }}
          open={successModal}
          // onOk={() => setSuccessModal(false)}
          // onCancel={() => setSuccessModal(false)}
          footer={null}
        >
          <div className={'rvpConfirmationModal'}>
            <svg
              style={{ justifySelf: 'center' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                stroke="#61CD85"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className={'rvpConfirmationModalTitle'}>Successful!</div>

            <div style={{ textAlign: 'center' }}>
              Your payment request with Reference Number{' '}
              <span style={{ color: '#6366F1' }}>{batchId}</span> has been
              successfully sent to the reviewer group for action
            </div>

            <div className={'rvpConfirmationModalActionButton'}>
              {/*<button className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1 ">*/}
              {/*    <span className="indicator-label fs-base">Cancel</span>*/}
              {/*</button>*/}

              <button
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                onClick={() => {
                  redirect();
                }}
              >
                <span className="indicator-label fs-base text-White">Ok</span>
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default RetailVendorPayments;
